/**
 * List Schema of Responsavel
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'

/* TODO: review generated schema */
export class ListResponsavelSchema extends Schema {
  readonly name = 'ListResponsavel'

  readonly fieldSet: FieldSet<Responsavel> = {
    idResponsavelPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    cnpj: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.cnpj(schema.model.cnpj),
      },
    }),
    razaoSocial: (): FieldComponent => ({
      is: Component.Render,
    }),
    nomeFantasia: (): FieldComponent => ({
      is: Component.Render,
    }),
    nomeContato: (): FieldComponent => ({
      is: Component.Render,
    }),
    telefone: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.telefone,
      },
    }),
    email: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataVencimento: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataVencimento),
      },
    }),
    urlLogoEmpresa: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(!!schema.model.urlLogoEmpresa),
      },
    }),
    slaHoras: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(!!schema.model.slaHoras),
      },
    }),
    tipoCriador: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.nomeTipoCriador,
      },
    }),
  }
}
